<template lang="pug">
.container
  h3 れんらくノート 管理アプリ
  gb-card.auth-card
    .auth-card-layout
      slot
  div(style="height: 60px;")
</template>
<script>
/* eslint-disable */
import GbCard from '@/components/atoms/GbCard.vue'
export default {
  name: 'AuthCard',
  components: {
    GbCard
  }
}
</script>
<style lang="stylus" scoped>
.container
  width 100%
  display flex
  flex-direction column
  justify-content center
  align-items center
.auth-card
  width 40vw
  height 50vh
  border-radius 5px
.logo
  width 300px
  height auto
  margin 16px
.auth-card-layout
  width 100%
  height 100%
  display flex
  flex-direction column
  justify-content space-around
  align-items stretch
</style>



// WEBPACK FOOTER //
// src/components/organisms/AuthCard.vue